<template>
  <div class="statistical-list">
    <table border="1" style="width: 100%; border-collapse: collapse; margin: 10px auto;">
      <thead>
        <tr style="background-color: #0066cc; color: #fff;">
          <th :rowspan="2">导师姓名</th>
          <th :rowspan="2">辅导学生数</th>
          <th :colspan="2">家校沟通</th>
          <th :colspan="2">师生互动</th>
          <th>学生行为记录</th>
        </tr>
        <tr style="background-color: #0066cc; color: #fff;">
          <template>
            <th>完成人数</th>
            <th>完成百分比</th>
          </template>
          <template>
            <th>完成人数</th>
            <th>完成百分比</th>
          </template>
          <template>
            <th>完成人数</th>
            <!-- <th>完成百分比</th> -->
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in teacherList" :key="index">
          <td>{{ item.teacherName }}</td>
          <td>{{ item.allotmentNum }}</td>
          <td>{{ item.homeSchoolVisitCount }}</td>
          <td>{{ item.homeSchoolVisitCompletionRate }}</td>
          <td>{{ item.teacherStudentInteractionCount }}</td>
          <td>{{ item.teacherStudentInteractionCompletionRate }}</td>
          <td>{{ item.studentBehaviorRecordCount }}</td>
        </tr>
      </tbody>
    </table>
    <!-- <div v-else><el-empty description="暂无数据"></el-empty></div> -->
  </div>
</template>

<script>
export default {
  props: ['teacherList'],
  data() {
    return {

    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
@import './statisticalList.scss';
</style>